const config = {
    apiKey: "AIzaSyCh1apaVaaOR2w-hclYibEOY2Fa-lVubcE",
    authDomain: "saru-tech.firebaseapp.com",
    databaseURL: "https://saru-tech.firebaseio.com",
    projectId: "saru-tech",
    storageBucket: "saru-tech.appspot.com",
    messagingSenderId: "118779350897",
    appId: "1:118779350897:web:d9e24bc9da4ae3d772b0d0",
    measurementId: "G-K777JVR3L5"
}

export default config;